"use strict";var e=require("../Object/objectAssign.cjs");exports.deferred=function(){var r,s=new Promise((function(e,s){r={resolve:e,reject:s}}));return e.objectAssign(s,r)};
//# sourceMappingURL=deferred.cjs.map
